flatpickr(".date-pick",
    {
        // See : https://flatpickr.js.org/examples/
        minDate: "today",
        maxDate: new Date().fp_incr(14),
        enableTime: false,
        dateFormat: "Y-d-m",
    }
);

flatpickr(".time-pick",
    {
        enableTime: true,
        noCalendar: true,
        minTime: "09:00",
        maxTime: "17:30",
        dateFormat: "H:i",
    }
);
